import React from "react";
import { useRouteMatch } from "react-router";
import { Route, Switch } from "react-router-dom";
import Header from "features/shared/layout/header/Header";
import ModuleContent from "features/shared/layout/content/ModuleContent";
import MessagesSection from "features/messages/components/sections/MessagesSection";
import RenderWrapper from "features/shared/components/renderWrapper/RenderWrapper";
import { loadPortalConfig } from "features/shared/helpers/modules";
import { useTranslation } from "react-i18next";

const portalConfig = loadPortalConfig();

const Messages = () => {
  // translations
  const t = useTranslation("shared\\moduleNames").t;

  const match = useRouteMatch();

  return (
    <RenderWrapper isVisible={() => portalConfig.useMessages}>
      <Switch>
        <Route path={match.path}>
          <Header title={t("messages.title")} includeBreadcrumbs />
          <ModuleContent>
            <MessagesSection />
          </ModuleContent>
        </Route>
      </Switch>
    </RenderWrapper>
  );
};

export default Messages;